// extracted by css-extract-rspack-plugin
export default {"cls1":"TransactionalPricingModal-cls1_rau","cls2":"TransactionalPricingModal-cls2_Erf TransactionalPricingModal-cls1_rau"};